"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Initials = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
var _calculateTextSize = _interopRequireDefault(require("./helpers/calculateTextSize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Initials = _styledComponents["default"].span.withConfig({
  displayName: "InitialsAvatarstyle__Initials",
  componentId: "sc-kxtjai-0"
})(function (props) {
  return (0, _styledComponents.css)(["color:", ";text-transform:uppercase;font-weight:", ";font-size:", ";", " ", ""], props.initialsAvatarTheme.appearance[props.appearance].textColor, props.theme.fontWeight[2], (0, _calculateTextSize["default"])(props.size, props.theme).sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["font-size:", ";"], (0, _calculateTextSize["default"])(props.size, props.theme).md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["font-size:", ";"], (0, _calculateTextSize["default"])(props.size, props.theme).lg)));
});
exports.Initials = Initials;